import { Grid, Paper } from "@material-ui/core";
import TextInputField from "components/Admin/InputFields/TextInputField";
import { BorderLinearProgress, FIELDS, ProgressBar } from "components/Admin/InputFields/utils";
import { HiddenInput } from "features/admin/Orders/actions/AddOrder";
import { useStyles } from "features/admin/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { MdSave } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components/macro";
import {
  setEditItem,
  fetchProductForEdit,
  selectEditItem,
  setProjectElements,
  updateGalleryItem,
} from "../adminGallerySlice";
import { ProjectForm, StyledSubmitButton } from "./AddGalleryItem";
import ProductsForProjectTable from "./ProductsForProjectTable";
import { useNavigate } from "react-router";

interface EditGalleryItemProps {}

const EditGalleryItem: React.FC<EditGalleryItemProps> = ({}) => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const { setValue, handleSubmit, control, errors, getValues } = useForm();
  const navigate = useNavigate();

  const { id } = useParams();
  const classes = useStyles();

  const editFields = useSelector(selectEditItem);

  useEffect(() => {
    //fetch gallery item for edit
    dispatch(fetchProductForEdit(id));

    return () => {
      dispatch(setEditItem([]));
      dispatch(setProjectElements([]));
    };
  }, []);

  const renderField = (field: any, idx: number) => {
    if (field.items) {
      return <></>;
    }
    const Field = FIELDS[field.type];
    return <Field item={field} key={idx} control={control} setValue={setValue} />;
  };

  const onSubmit = (data: any) => {
    dispatch(
      updateGalleryItem(data, id, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return editFields?.data ? (
    <EditGalleryItemContainer>
      <Paper className={classes.paper}>
        <Grid container direction="row" wrap="wrap" align-items="center">
          <p>
            Мета заглавие (дължина): 20 - 60 знака
            <br />
            Мета тагове (брой): 4 - 9 тага
            <br />
            Мета описание (дължина): 50 - 160 знака
          </p>
          <ProjectForm onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            {editFields.data.map((item: any, idx: number) => {
              return renderField(item, idx);
            })}
            <HiddenInput>
              <TextInputField
                item={{
                  required: true,
                  type: "text",
                  title: "Добавени климатици",
                  name: "items",
                }}
                control={control}
                reset={false}
                setValue={setValue}
                errors={errors}
              />
            </HiddenInput>
            <ProductsForProjectTable
              setValue={setValue}
              getValues={getValues}
              activeValues={editFields.data.find((item: any) => {
                const keys = Object.keys(item);
                return keys.includes("items");
              })}
            />
            <ProgressBar>
              <BorderLinearProgress variant="determinate" value={progress} />
            </ProgressBar>
            <StyledSubmitButton variant="contained" color="primary" type="submit" startIcon={<MdSave size="1.5rem" />}>
              Промени проект
            </StyledSubmitButton>
          </ProjectForm>
        </Grid>
      </Paper>
    </EditGalleryItemContainer>
  ) : (
    <></>
  );
};

const EditGalleryItemContainer = styled.div``;

export default EditGalleryItem;
